import { Button } from '@/components/ui/button';
import { Card, CardFooter, CardHeader } from '@/components/ui/card';
import renewModal from '@/assets/images/filter/renewModal.png';

interface RenewFilterModalProps {
  onRenew?: () => void;
  onRemove?: () => void;
}

export default function RenewFilterModal({ onRenew, onRemove }: RenewFilterModalProps): JSX.Element {
  return (
    <Card className="flex flex-col w-[340px] bg-[#2B2D2F] rounded-[12px] border border-solid border-transparent">
      <CardHeader className="flex flex-col items-start gap-4 pt-4 pr-4 pb-4 pl-4 bg-transparent">
        <div className="flex flex-col items-start justify-center gap-4 w-full">
          <div className="relative w-[57px] h-[83px]">
            <img className="absolute w-full h-full " alt="StyleFilter preview" src={renewModal} />
          </div>

          <h2 className="w-fit text-white text-[24px] font-normal text-collection-1-grey-5 text-2xl tracking-[-0.48px] whitespace-nowrap">
            Renew StyleFilter™ Uses
          </h2>
        </div>

        <p className="w-full text-white text-[16px] font-normal text-collection-1-grey-3">
          You have used all your minutes for this filter, please renew the filter in the marketplace.
        </p>
      </CardHeader>

      <CardFooter className="flex flex-col items-start justify-center gap-2 pt-4 pr-4 pb-4 pl-4 w-full">
        <Button
          variant="nobg"
          onClick={onRenew}
          className="w-full py-3 px-4 bg-[#FF5B27] text-[white] rounded-[8px] text-contextual-content-primary-contrast font-desktop-interactive-primary font-[number:var(--desktop-interactive-primary-font-weight)] text-[length:var(--desktop-interactive-primary-font-size)] tracking-[var(--desktop-interactive-primary-letter-spacing)] leading-[var(--desktop-interactive-primary-line-height)]"
        >
          Renew StyleFilter™ uses
        </Button>

        <Button
          onClick={onRemove}
          variant="nobg"
          className="w-full py-3 px-4 bg-[#55362D] text-[#FF5B27] rounded-[8px] text-contextual-interactive-primary font-desktop-interactive-primary font-[number:var(--desktop-interactive-primary-font-weight)] text-[length:var(--desktop-interactive-primary-font-size)] tracking-[var(--desktop-interactive-primary-letter-spacing)] leading-[var(--desktop-interactive-primary-line-height)]"
        >
          Remove filter
        </Button>
      </CardFooter>
    </Card>
  );
}
